import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Flex } from 'antd';

const MetricSelector = ({ onChage, metricsList, selected_metrics }) => {
  const items = Object.entries(metricsList).map(([key, metric]) => ({
    key,
    label: <span className='text-xs font-normal'>{metric.name}</span>,
  }));

  const handleMenuClick = ({ key }) => {
    onChage({ key });
  };

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleMenuClick,
      }}
    >
      <Flex gap='small' align='center' className='cursor-pointer text-orange flex'>
        <DownOutlined />
        {metricsList[selected_metrics]?.name || 'Select Metric'}
      </Flex>
    </Dropdown>
  );
};

export default MetricSelector;
